// extracted by mini-css-extract-plugin
module.exports = {"page-header":"page-header-wLejI","breadcrumb":"breadcrumb-f6vFL"};